<template>
    <div>
        <vue-multiselect
            v-model="selectedOption"
            class="w-100"
            :options="options"
            :placeholder="placeholder"
            :tag-placeholder="tagPlaceholder"
            :taggable="taggable"
            :show-labels="false"
            track-by="name"
            label="name"
            :multiple="multiple"
            :disabled="disabled"
            @select="selectItem($event)"
            @remove="removeItem($event)"
            @tag="addNewService($event)"
        ></vue-multiselect>
    </div>
</template>
<script>

export default {
    props: {
        modelValue: {
            type: [String, Object, Array, null, Number],
            default: null
        },
        placeholder: {
            type: String,
            default: 'Search or add new service'
        },
        tagPlaceholder: {
            type: String,
            default: 'Add this as new service'
        },
        services: {
            type: Array,
            default: []
        },
        taggable: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            options: this.services,
            selectedOption: null,
        }
    },
    mounted() {
        this.prepareSelectedOption();
    },
    computed: {

    },
    watch: {
        modelValue(newVal) {
            //this.selectedOption = newVal;
        }
    },
    methods: {
        addNewService(newService) {
            let tag = {
                id: '',
                name: newService,
            };
            this.selectedOption = tag;
            this.options.push(tag);

            // Update service name to parent component
            this.$emit('update:modelValue', "");
            this.$emit('updateServiceName', newService);
        },
        selectItem(event) {
            let serviceId = event.id;
            let serviceName = event.name;
            this.$emit('update:modelValue', serviceId);
            this.$emit('updateServiceName', serviceName);
        },

        removeItem(event) {
            // Get the all ids from the selected option
            // const ids = this.selectedOption.map(option => option.id);
            // this.$emit('update:modelValue', ids);
        },
        prepareSelectedOption() {
            this.selectedOption = this.options.filter(option =>
                this.modelValue===option.id
            );
        }
    }
}
</script>
